export default __webpack_public_path__ + "static/media/crowddata.03c2bb05.jpg";